var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 7.646c2.723-1.707 9.325-4.892 17.43-4.63 10.133.326 10.133 10.513 4.686 14.435-5.448 3.923-9.806 5.448-14.055 4.577-4.248-.872-4.792-5.23-1.96-6.81 2.833-1.58 5.066-1.307 6.428-.871.613.196 1.108.654 1.144.872-1.053-.418-3.65-.937-5.61.326-2.452 1.58-2.616 3.76-.545 4.576 2.07.817 8.334.382 11.112-3.05 2.778-3.432 2.778-7.028-.327-9.424-3.105-2.397-9.207-2.452-18.304 0zm21.5 17.342c-2.723 1.707-9.325 4.892-17.43 4.63C-.814 29.293-.814 19.106 4.633 15.184c5.448-3.922 9.806-5.448 14.055-4.576 4.248.872 4.792 5.23 1.96 6.81-2.833 1.58-5.066 1.307-6.428.87-.613-.195-1.108-.653-1.144-.87 1.053.417 3.65.936 5.61-.327 2.452-1.58 2.615-3.76.545-4.576-2.07-.818-8.334-.382-11.112 3.05-2.778 3.432-2.778 7.027.327 9.424 3.106 2.397 9.207 2.452 18.304 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpr);
export default __webpack_public_path__ + "static/media/DPR.5f8f4fdc9368473b99cc5cf993485891.svg";
export { ForwardRef as ReactComponent };